import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";

/** Guarda o cache das queries públicas do site (site_content/plans/banners) no
 *  localStorage, pra próxima visita já renderizar o último conteúdo real
 *  publicado em vez do texto padrão do código enquanto o Supabase responde. */
export const PUBLIC_CACHE_KEYS = ["site_content", "plans", "banners"];

export const persister = createSyncStoragePersister({
  storage: typeof window !== "undefined" ? window.localStorage : undefined,
  key: "contato-site-cache",
});
